<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"/>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'PayOverdue',

  components: {
    Loading
  },

  data () {
    return {
      isLoading: false,
      fullPage: true,
      endpoint: null
    }
  },

  mounted () {
    let queryParams = this.$route.params
    const id = queryParams.id
    const type = queryParams.type

    if (type === 'subscriptions') {
      this.endpoint = 'subscriptions'
    } else if (type === 'waitlist') {
      this.endpoint = 'waitlistsubscriptions'
    }

    this.getContainerDetails(id).then((data) => {
      if (data.apply_overdue_fee && !data.overdue_fee_payed) {
        let unscheduled = false
        if (data.nets_details.is_unscheduled && data.nets_details.unscheduled_subscription_id	!== null) {
          unscheduled = true
        }

        this.payOverdueFee(data.id, data.payment_method, type, unscheduled)
      } else {
        this.isLoading = true
        this.payOverdue(data.id, type)
      }
    }).catch(() => {
      this.$router.push({name: 'dashboard'})
    })
  },

  methods: {
    getContainerDetails (id) {
      return new Promise((resolve, reject) => {
        this.axios.get(`${this.endpoint}/${id}`).then(({data}) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
      });
    },

    payOverdueFee (id, paymentMethod, type, unscheduled = false) {
      if (paymentMethod === 'nets') {
        if (unscheduled) {
          this.isLoading = true

          let data = {
            unscheduled: true
          }

          this.axios.post(`subscriptions/${id}/overdue/fee/charge`, data).then(() => {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: this.$t('globals.validation.success.overdue_fee_payment_successful'),
              type: 'success',
              align: 'right'
            })

            this.$events.$emit('updateactivesubscription')

            this.redirect(id)
          }).catch((error) => {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })

            this.redirect(id)
          })
        } else {
          this.$router.push({name: 'checkout_overdue_fee', params: { id: id, container: type }})
        }
      } else {
        this.axios.post(`${this.endpoint}/${id}/overdue/fee/payment`).then(({data}) => {
          if (data.success) {
            window.location.href = data.url
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })

            this.redirect(id)
          }
        }).catch((error) => {
          if (error.response) {
            if (error.response.data.message) {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.error'),
                message: error.response.data.message,
                type: 'error',
                align: 'right'
              })
            } else {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.something_went_wrong'),
                message: this.$t('globals.validation.errors.try_again_later'),
                type: 'error',
                align: 'right'
              })
            }
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
          }

          this.redirect(id)
        })
      }
    },

    payOverdue (id, type) {
      this.axios.post(`${this.endpoint}/${id}/overdue/pay`).then(({data}) => {
        if (data.payment_method === 'mobile_pay') {
          let redirectUrl = data.url

          if (process.env.NODE_ENV === 'development') {
            this.$router.push({
              name: 'mobile_pay_success',
              query: {
                id: id,
                type: type,
                op: 'status'
              }
            })
          } else {
            window.location.href = redirectUrl
          }
        } else if (data.payment_method === 'vipps') {
          window.location.href = data.url
        } else {
          let container = data.model

          if (container.status === 'active') {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: this.$t('globals.validation.success.overdue_payment_successful'),
              type: 'success',
              align: 'right'
            })

            this.redirectToSuccessPage(id)
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: this.$t('globals.validation.errors.overdue_payment_failed'),
              type: 'warning',
              align: 'right'
            })

            this.redirectToFailedPage(id)
          }
        }
      }).catch((error) => {
        if (error.response.data.message) {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.error'),
            message: error.response.data.message,
            type: 'error',
            align: 'right'
          })
        }

        this.redirectToFailedPage(id)
      })
    },

    redirectToSuccessPage(containerId, timeout = 1500) {
      let query = {
        container: this.endpoint === 'subscriptions' ? 'subscription' : 'waitlist',
        containerId: containerId,
        overdue: true
      }

      setTimeout(() => {
        this.$router.push({
          name: 'success',
          query: query
        })
      }, timeout)
    },

    redirectToFailedPage(containerId) {
      let query = {
        container: this.endpoint === 'subscriptions' ? 'subscription' : 'waitlist',
        containerId: containerId,
        overdue: true
      }

      setTimeout(() => {
        this.$router.push({
          name: 'failed',
          query: query
        })
      }, 1500)
    },

    redirect (id) {
      this.isLoading = false

      if (this.endpoint === 'subscriptions') {
        setTimeout(() => {
          this.$router.push({name: 'subscriptiondashboard', params: { subscriptionId: id }},
            () => {
              this.$router.go()
            }
          )
        }, 3000)
      } else if (this.endpoint === 'waitlistsubscriptions') {
        setTimeout(() => {
          this.$router.push({name: 'wait_list'},
            () => {
              this.$router.go()
            }
          )
        }, 3000)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/payment/PayOverdue.vue